module.exports = __webpack_public_path__ + "img/twitter.613eb10.svg";